import { AbsenceCategorySummary, CarryOver, PeriodType } from './types';
import { diff, parseDate } from '../../../../../../utils/dateUtils';
import {
  formatPeriodBounds,
  Period,
} from '../../../../../../components/PeriodNav/formatPeriod';

export const getSummaryPeriod = (
  summary: AbsenceCategorySummary,
  periodType: PeriodType,
) => {
  switch (periodType) {
    case 'next':
      return summary.nextPeriod;
    case 'previous':
      return summary.prevPeriod;
    case 'current':
      return summary.curPeriod;
  }
};

export const getMainPeriodLabelAmount = (
  summary: AbsenceCategorySummary,
  periodType: PeriodType,
): number | null => {
  switch (periodType) {
    case 'next':
      return summary.nextPeriod.upcoming;
    case 'previous':
      return summary.prevPeriod.taken;
    case 'current':
      return summary.curPeriod.available;
  }
};

export const getExpiringCarryOvers = (
  now: Date,
  carryOvers: CarryOver[],
  expireInDaysThreshold: number,
): CarryOver[] => {
  return carryOvers.filter((carryOver) => {
    if (carryOver.expired > 0) {
      // already expired
      return null;
    }
    const expire = expireInDays(now, carryOver);
    if (carryOver.amount - carryOver.used <= 0) {
      // all used, nothing to expire
      return false;
    }
    return expire !== null && expire > 0 && expire < expireInDaysThreshold;
  });
};

export const expireInDays = (
  now: Date,
  carryOver: CarryOver,
): number | null => {
  if (!carryOver.expireOn) {
    return null;
  }
  return Math.max(0, diff(new Date(carryOver.expireOn), now, 'day'));
};

export type { Period };

type PeriodStr = { startDate: string; endDate: string };

export const createPeriod = ({ startDate, endDate }: PeriodStr): Period => ({
  start: parseDate(startDate),
  end: parseDate(endDate),
});

export const createYearPeriods = (summary: {
  previousPeriod: PeriodStr;
  currentPeriod: PeriodStr;
  nextPeriod: PeriodStr;
}): Period[] => [
  createPeriod(summary.previousPeriod),
  createPeriod(summary.currentPeriod),
  createPeriod(summary.nextPeriod),
];

export const formatPeriodName = (periodStr: PeriodStr) => {
  const { start, end } = formatPeriodBounds(createPeriod(periodStr));
  return `${start} - ${end}`;
};
